import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Studentschooldarpan.css";

/* =========================================================
   DATA  (har item ka apna color hai → "c")
========================================================= */

const slides = [
  {
    tag: "STUDENT SCHOOL DARPAN",
    title: "Empowering Digital Education",
    text: "A modern digital platform for schools, students, teachers and education services.",
    icon: "🎓",
  },
  {
    tag: "SMART SCHOOL SERVICES",
    title: "Everything About Your School",
    text: "Access school information, academic services and education resources in one place.",
    icon: "🏫",
  },
  {
    tag: "EDUCATION OPPORTUNITIES",
    title: "Discover. Learn. Grow.",
    text: "Explore education programs, schemes, student services and connected digital portals.",
    icon: "🚀",
  },
];

const services = [
  { icon: "🎓", title: "Student Portal", text: "Access student and academic services.", url: "/Login", c: "#6366f1" },
  { icon: "🏫", title: "School Services", text: "Explore school information and services.", url: "#", c: "#ec4899" },
  { icon: "📄", title: "Download Forms", text: "Download useful education formats.", url: "#", c: "#f59e0b" },
  { icon: "💬", title: "Contact Us", text: "Connect with our support team.", url: "/ContactUs", c: "#14b8a6" },
];

const portals = [
  { short: "GS", title: "Gyan Sankalp", text: "Learning & academic support", c: "#6366f1" },
  { short: "SS", title: "Samagra Shiksha", text: "Education management portal", c: "#ec4899" },
  { short: "SE", title: "Sanskrit Education", text: "Sanskrit education services", c: "#f59e0b" },
  { short: "PS", title: "Private School", text: "Private school management", c: "#14b8a6" },
  { short: "SC", title: "Schools", text: "School administration", c: "#0ea5e9" },
  { short: "ST", title: "Staff", text: "Staff & employee services", c: "#8b5cf6" },
  { short: "CT", title: "Citizen", text: "Citizen services", c: "#22c55e" },
  { short: "SD", title: "Students", text: "Student services", c: "#f43f5e" },
];

const updates = [
  { icon: "📰", title: "Latest News", text: "View latest education updates.", c: "#0ea5e9" },
  { icon: "📋", title: "Circulars", text: "Access important notifications.", c: "#8b5cf6" },
  { icon: "🏆", title: "Achievements", text: "Explore school achievements.", c: "#f59e0b" },
  { icon: "📢", title: "Press Release", text: "Read latest announcements.", c: "#f43f5e" },
];

const partners = [
  { short: "RJ", name: "Rajasthan", c: "#f43f5e" },
  { short: "DI", name: "Digital India", c: "#f59e0b" },
  // { short: "UD", name: "UDISE+", c: "#14b8a6" },
  { short: "NC", name: "NCERT", c: "#6366f1" },
  { short: "RB", name: "RBSE", c: "#ec4899" },
];

const heroStats = [
  { value: "10K+", label: "Schools" },
  { value: "5L+", label: "Students" },
  { value: "25K+", label: "Staff" },
];

/* Internal route → <Link>, baaki sab → normal <a> */
function SmartLink({ to, children, ...rest }) {
  if (to && to.startsWith("/")) {
    return (
      <Link to={to} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <a href={to || "#"} {...rest}>
      {children}
    </a>
  );
}

/* =========================================================
   COMPONENT
========================================================= */

export default function Student_school_darpan() {
  const [slide, setSlide] = useState(0);
  const [popup, setPopup] = useState(false);

  /* Theme: saved value pehle hi read hoti hai
     (purane code me save-effect load se pehle chal kar "light" overwrite kar deta tha) */
  const [dark, setDark] = useState(() => {
    try {
      return localStorage.getItem("private_school_theme") === "dark";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("private_school_theme", dark ? "dark" : "light");
    } catch {
      /* ignore */
    }
  }, [dark]);

  /* Auto slider — slide change hone par timer reset hota hai */
  useEffect(() => {
    const timer = setInterval(() => {
      setSlide((prev) => (prev + 1) % slides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, [slide]);

  /* Toast: 3 sec baad sirf pehli baar dikhao */
  useEffect(() => {
    let shown = false;
    try {
      shown = !!localStorage.getItem("student_popup_shown");
    } catch {
      /* ignore */
    }
    if (shown) return;

    const timer = setTimeout(() => {
      setPopup(true);
      try {
        localStorage.setItem("student_popup_shown", "true");
      } catch {
        /* ignore */
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  /* Toast 6 sec baad auto-hide */
  useEffect(() => {
    if (!popup) return;
    const hideTimer = setTimeout(() => setPopup(false), 6000);
    return () => clearTimeout(hideTimer);
  }, [popup]);

  const next = () => setSlide((prev) => (prev + 1) % slides.length);
  const previous = () =>
    setSlide((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <main className={`darpan-page ${dark ? "dark" : ""}`}>
      {/* ================= HERO ================= */}
      <section className="darpan-hero" aria-roledescription="carousel">
        <span className="hero-blob blob-1" aria-hidden="true" />
        <span className="hero-blob blob-2" aria-hidden="true" />
        <span className="hero-blob blob-3" aria-hidden="true" />

        {slides.map((item, index) => (
          <div
            key={item.title}
            className={`hero-slide theme-${index} ${
              slide === index ? "active" : ""
            }`}
            aria-hidden={slide !== index}
          >
            <div className="hero-content">
              <span className="hero-tag">{item.tag}</span>
              <h1>{item.title}</h1>
              <p>{item.text}</p>

              <div className="hero-buttons">
                <a href="#services">Explore Services →</a>
                <a href="#portals" className="outline-btn">
                  Education Portals
                </a>
              </div>
            </div>

            <div className="hero-card">
              <div className="hero-card-icon">{item.icon}</div>

              <div className="hero-card-content">
                <span>STUDENT SCHOOL DARPAN</span>
                <h3>Digital Education</h3>
                <p>Schools • Students • Teachers</p>
              </div>

              <div className="hero-card-stats">
                {heroStats.map((s) => (
                  <div key={s.label}>
                    <strong>{s.value}</strong>
                    <small>{s.label}</small>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}

        <button
          className="slider-btn prev"
          onClick={previous}
          aria-label="Previous slide"
        >
          ‹
        </button>
        <button
          className="slider-btn next"
          onClick={next}
          aria-label="Next slide"
        >
          ›
        </button>

        <div className="slider-dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={slide === index ? "active" : ""}
              onClick={() => setSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </section>

      {/* ================= SERVICES ================= */}
      <section className="section" id="services">
        <div className="section-title">
          <span>OUR SERVICES</span>
          <h2>
            Everything You Need <b>In One Place</b>
          </h2>
          <p>Simple and modern education services for everyone.</p>
        </div>

        <div className="service-grid">
          {services.map((s) => (
            <SmartLink
              to={s.url}
              className="service-card"
              key={s.title}
              style={{ "--c": s.c }}
            >
              <div className="service-icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
              <span>Explore →</span>
            </SmartLink>
          ))}
        </div>
      </section>

      {/* ================= PORTALS ================= */}
      <section className="section portals" id="portals">
        <div className="section-title">
          <span>QUICK ACCESS</span>
          <h2>
            Education <b>Portals</b>
          </h2>
          <p>Access connected education platforms and services.</p>
        </div>

        <div className="portal-grid">
          {portals.map((p) => (
            <a
              href="#"
              className="portal-card"
              key={p.title}
              style={{ "--c": p.c }}
            >
              <div className="portal-icon">{p.short}</div>
              <h3>{p.title}</h3>
              <p>{p.text}</p>
              <span>Open Portal ↗</span>
            </a>
          ))}
        </div>
      </section>

      {/* ================= RESULT ================= */}
      <section className="result-section">
        <div className="result-card">
          <div className="result-icon">🎓</div>

          <div className="result-text">
            <span>ACADEMIC RESULTS</span>
            <h2>Class 5 & 8 Board Result 2026</h2>
            <p>View examination results and academic performance.</p>
          </div>

          <a href="#">View Result →</a>
        </div>
      </section>

      {/* ================= UPDATES ================= */}
      <section className="section" id="updates">
        <div className="section-title">
          <span>LATEST UPDATES</span>
          <h2>
            What's <b>Happening?</b>
          </h2>
          <p>Latest education news, announcements and activities.</p>
        </div>

        <div className="update-grid">
          {updates.map((u) => (
            <a
              href="#"
              className="update-card"
              key={u.title}
              style={{ "--c": u.c }}
            >
              <div className="update-icon">{u.icon}</div>
              <h3>{u.title}</h3>
              <p>{u.text}</p>
              <span>Read More →</span>
            </a>
          ))}
        </div>
      </section>

      {/* ================= PARTNERS ================= */}
      <section className="partners" id="partners">
        <div className="section-title">
          <span>CONNECTED ECOSYSTEM</span>
          <h2>
            Our <b>Partners</b>
          </h2>
          <p>Building a connected education ecosystem.</p>
        </div>

        <div className="partner-list">
          {partners.map((p) => (
            <div className="partner" key={p.name} style={{ "--c": p.c }}>
              <strong>{p.short}</strong>
              <span>{p.name}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ================= THEME TOGGLE ================= */}
      <button
        className="theme-toggle"
        onClick={() => setDark((d) => !d)}
        aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
        title={dark ? "Light mode" : "Dark mode"}
      >
        {dark ? "☀️" : "🌙"}
      </button>

      {/* ================= TOAST ================= */}
      {popup && (
        <div className="toast" role="status" aria-live="polite">
          <div className="toast-icon">🔔</div>

          <div className="toast-body">
            <span>IMPORTANT UPDATE</span>
            <h4>Student & School Profile Update</h4>
            <p>
              Please complete the required student, school, teacher and
              academic profile information.
            </p>
          </div>

          <button
            className="toast-close"
            onClick={() => setPopup(false)}
            aria-label="Close notification"
          >
            ✕
          </button>

          <div className="toast-progress" />
        </div>
      )}
    </main>
  );
}